import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import ReviewValue from "~/chat/vue/widget/tabs/reviews/ReviewValue.vue";
import ChatFormInlineSvgIcon from "~/chat/vue/widget/form/fields/ChatFormInlineSvgIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";


const __default__ = {
    name: "ChatStarsInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputWrapperWithIcon, { field: _ctx.field }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ChatFormInlineSvgIcon, { field: _ctx.field }, null, 8, ["field"]),
        _createTextVNode(" " + _toDisplayString(_unref(placeholder)), 1)
      ]),
      _createVNode(ReviewValue, {
        style: {"font-size":"2em !important"},
        "model-value": _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
        system: 5,
        "model-is-listening": ""
      }, null, 8, ["model-value"])
    ]),
    _: 1
  }, 8, ["field"]))
}
}

})